/* eslint-disable import/no-default-export */
export default [
    {
        title: 'Exportacion',
        fontIcon: 'ship',
        resource: 'Exportaciones',
        action: 'ver-exportaciones',
        children: [
            {
                route: 'exportaciones-dashboard',
                title: 'Dashboard',
                icon: 'LayoutIcon',
                resource: 'Exportaciones',
                action: 'ver-exportaciones-dashboard',
                children: [
                    {
                        route: 'exportaciones-dashboard-resumen-mercado',
                        title: 'Resumen por Mercado',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-dashboard-resumen-mercado',
                    },
                    {
                        route: 'exportaciones-dashboard-monitor-anticipo',
                        title: 'Monitor Anticipo',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-dashboard-monitor-anticipo',
                    },
                    {
                        route: 'exportaciones-dashboard-monitor-contenedores-facturar',
                        title: 'Contenedores X Facturar',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-dashboard-monitor-contenedores-facturar',
                    },
                    {
                        route: 'exportaciones-dashboard-monitor-ventas',
                        title: 'Monitor ventas',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-dashboard-monitor-ventas',
                    },
                    {
                        route: 'exportaciones-dashboard-year-to-year',
                        title: 'exportaciones.dashboard.page.yearToYear',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-dashboard-year-to-year',
                    },
                    {
                        route: 'exportaciones-dashboard-monitor-embarque',
                        title: 'Monitor Embarques',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-dashboard-monitor-embarque',
                    },
                    // DOCEX
                    {
                        route: 'exportaciones-dashboard-monitor-documentacion',
                        title: 'Monitor Documentación',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-dashboard-monitor-documentacion',
                    },
                    // DOCEX
                    // CONTENDORES
                    {
                        route: 'exportaciones-dashboard-monitor-contenedores',
                        title: 'Monitor Contenedores',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-dashboard-monitor-contenedores',
                    },
                    {
                        route: 'exportaciones-dashboard-monitor-ordenes-pedido',
                        title: 'Monitor Ordenes Pedido',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-dashboard-monitor-ordenes-pedido',
                    },
                    {
                        route: 'exportaciones-dashboard-monitor-ordenes-pedido-fc',
                        title: 'Monitor Ordenes Pedido Fc',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-dashboard-monitor-ordenes-pedido-fc',
                    },
                ],
            },
            {
                route: 'exportaciones-configuracion',
                title: 'Configuracion',
                icon: 'SettingsIcon',
                resource: 'Exportaciones',
                action: 'ver-exportaciones-configuracion',
                children: [
                    {
                        route: 'exportaciones-configuracion-firmas-documentos',
                        title: 'Firmas de documentos',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-configuracion-firmas-documentos',
                    },
                    {
                        route: 'exportaciones-configuracion-planta-usuario',
                        title: 'Plantas Asignadas',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-configuracion-planta-usuario',
                    },
                    {
                        route: 'exportaciones-configuracion-documento',
                        title: 'Documento',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-configuracion-documento',
                    },
                    {
                        route: 'exportaciones-configuracion-parametros-exportaciones',
                        title: 'exportaciones.configuracion.page.parametros_expo',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-configuracion-parametros-exportaciones',
                    },
                ],
            },
            {
                title: 'Mantenimiento',
                icon: 'EditIcon',
                resource: 'Exportaciones',
                action: 'ver-exportaciones-mantenimiento',
                children: [
                    //Exportaciones 2022 - ??
                    {
                        route: 'exportaciones-mantenimiento-alertas-correo',
                        title: 'Alerta de Correo',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-mantenimiento-alertas-correo',
                    },
                    {
                        route: 'exportaciones-mantenimiento-ficha-cliente',
                        title: 'exportaciones.configuracion.page.ficha_cliente',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-mantenimiento-ficha-cliente',
                    },
                    {
                        route: 'exportaciones-mantenimiento-maestro-mercado',
                        title: 'Mercados',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-mantenimiento-maestro-mercado',
                    },
                    {
                        route: 'exportaciones-mantenimiento-maestro-puerto',
                        title: 'Puertos',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-mantenimiento-maestro-puerto',
                    },
                    {
                        route: 'exportaciones-mantenimiento-segmento',
                        title: 'Segmento',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-mantenimiento-segmento',
                    },
                    {
                        route: 'exportaciones-mantenimiento-maestro-agencia-naviera',
                        title: 'exportaciones.mantenimiento.page.ag_naviera',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-mantenimiento-maestro-agencia-naviera',
                    },
                    {
                        route: 'exportaciones-mantenimiento-maestro-linea-naviera',
                        title: 'exportaciones.mantenimiento.page.ln_naviera',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-mantenimiento-maestro-linea-naviera',
                    },
                    {
                        route: 'exportaciones-mantenimiento-maestro-tipo-contrato',
                        title: 'Tipos de Contrato',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-mantenimiento-maestro-tipo-contrato',
                    },
                    {
                        route: 'exportaciones-mantenimiento-maestro-tipo-contenedor',
                        title: 'exportaciones.mantenimiento.page.tipo_contenedor',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-mantenimiento-maestro-tipo-contenedor',
                    },
                    {
                        route: 'exportaciones-mantenimiento-maestro-terminal-embarque',
                        title: 'exportaciones.mantenimiento.page.terminal_embarque',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-mantenimiento-maestro-terminal-embarque',
                    },
                    {
                        route: 'exportaciones-mantenimiento-maestro-buque',
                        title: 'Buques',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-mantenimiento-maestro-buque',
                    },
                    {
                        route: 'exportaciones-mantenimiento-maestro-transportadora',
                        title: 'Transportadoras',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-mantenimiento-maestro-transportadora',
                    },
                    {
                        route: 'exportaciones-mantenimiento-maestro-conductor',
                        title: 'Conductores',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-mantenimiento-maestro-conductor',
                    },
                    {
                        route: 'exportaciones-mantenimiento-maestro-vehiculo',
                        title: 'Vehiculos',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-mantenimiento-maestro-vehiculo',
                    },
                    {
                        route: 'exportaciones-mantenimiento-maestro-planta-relacionada',
                        title: 'exportaciones.mantenimiento.page.planta_relacionadas',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-mantenimiento-maestro-planta-relacionada',
                    },
                    {
                        route: 'exportaciones-mantenimiento-maestro-puerto-ciudad',
                        title: 'exportaciones.mantenimiento.page.ciudades_puerto',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-mantenimiento-maestro-puerto-ciudad',
                    },
                    // Exportaciones 2022 - ??
                    {
                        route: 'exportaciones-mantenimiento-parametros-china',
                        title: 'Parametros China',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-mantenimiento-parametros-china',
                    },
                    {
                        route: 'exportaciones-mantenimiento-maestro-tipo-vehiculo',
                        title: 'Tipos de Vehiculos',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-mantenimiento-maestro-tipo-vehiculo',
                    },
                    {
                        route: 'exportaciones-mantenimiento-maestro-peso-bruto',
                        title: 'Tipo de peso bruto',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-mantenimiento-maestro-peso-bruto',
                    },
                    {
                        route: 'exportaciones-mantenimiento-maestro-aseguradora',
                        title: 'Aseguradoras',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-mantenimiento-maestro-aseguradora',
                    },
                    {
                        route: 'exportaciones-mantenimiento-maestro-jefe-planta',
                        title: 'Jefe Planta',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-mantenimiento-maestro-jefe-planta',
                    },
                    {
                        route: 'exportaciones-mantenimiento-concepto-tarifa',
                        title: 'exportaciones.mantenimiento.page.concepto_tarifa',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-mantenimiento-concepto-tarifa',
                    },
                    {
                        route: 'exportaciones-mantenimiento-distrito-aduanero',
                        title: 'Distrito Aduanero',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-mantenimiento-distrito-aduanero',
                    },
                    {
                        route: 'exportaciones-mantenimiento-maestro-bancos',
                        title: 'Bancos',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-mantenimiento-maestro-bancos',
                    },
                    {
                        route: 'exportaciones-mantenimiento-maestro-direccion-entrega',
                        title: 'exportaciones.mantenimiento.direccion_entrega',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-mantenimiento-maestro-direccion-entrega',
                    },
                    {
                        route: 'exportaciones-mantenimiento-maestro-courier',
                        title: 'exportaciones.mantenimiento.courier',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-mantenimiento-maestro-courier',
                    },
                ],
            },
            {
                title: 'Transacciones',
                fontIcon: 'exchange-alt',
                resource: 'Exportaciones',
                action: 'ver-exportaciones-transacciones',
                children: [
                    {
                        route: 'exportaciones-transaccion-emision-proforma',
                        title: 'exportaciones.transacciones.page.emision_Proforma',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-transaccion-emision-proforma',
                    },
                    {
                        route: 'exportaciones-transaccion-emision-cobro',
                        title: 'exportaciones.transacciones.page.emision_cobro',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-transaccion-emision-cobro',
                    },
                    {
                        route: 'exportaciones-transacciones-documentos',
                        title: 'Formatos',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-transacciones-documentos',
                    },
                    {
                        route: 'exportaciones-transacciones-tarifa-naviera',
                        title: 'exportaciones.transacciones.page.emision_tarifa',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-transacciones-tarifa-naviera',
                    },
                    {
                        route: 'exportaciones-transacciones-planificacion-embarque',
                        title: 'exportaciones.transacciones.page.planificacion_embarque',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-transacciones-planificacion-embarque',
                    },
                    {
                        route: 'exportaciones-transacciones-despacho-embarque',
                        title: 'exportaciones.transacciones.page.despacho_embarque',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-transacciones-despacho-embarque',
                    },
                    {
                        route: 'exportaciones-transacciones-reserva-booking',
                        title: 'exportaciones.transacciones.page.emision_booking',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-transacciones-reserva-booking',
                    },
                    {
                        route: 'exportaciones-transacciones-pre-embarque',
                        title: 'exportaciones.transacciones.page.pre_embarque',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-transacciones-pre-embarque',
                    },
                    {
                        route: 'exportaciones-transacciones-proceso-embarque',
                        title: 'exportaciones.transacciones.page.process_pre_embarque',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-transacciones-proceso-embarque',
                    },

                    {
                        route: 'exportaciones-transacciones-generar-secuencia',
                        title: 'exportaciones.transacciones.page.generar_sec',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-transacciones-generar-secuencia',
                    },

                    {
                        route: 'exportaciones-transacciones-proceso-roleo',
                        title: 'Roleo',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-trasacciones-proceso-roleo',
                    },
                    {
                        route: 'exportaciones-transacciones-planificacion-booking',
                        title: 'exportaciones.transacciones.page.planificacion_booking',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-transacciones-planificacion-booking',
                    },
                    {
                        route: 'exportaciones-transacciones-emision-nota-credito',
                        title: 'exportaciones.transacciones.page.nota_credito',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-transacciones-emision-nota-credito',
                    },
                    {
                        route: 'exportaciones-transacciones-emision-nota-debito',
                        title: 'exportaciones.transacciones.page.nota_debito',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-transacciones-emision-nota-debito',
                    },
                    {
                        route: 'exportaciones-transaccion-emision-factura-comercial',
                        title: 'exportaciones.transacciones.page.emision_fac_comercial',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-transaccion-emision-factura-comercial',
                    },
                    {
                        route: 'exportaciones-transaccion-embarque-no-exportado',
                        title: 'exportaciones.transacciones.page.emb_no_exportado',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-transaccion-embarque-no-exportado',
                    },
                    {
                        route: 'exportaciones-transaccion-calculo-peso-bruto',
                        title: 'exportaciones.transacciones.page.peso_bruto',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-transaccion-calculo-peso-bruto',
                    },
                    {
                        route: 'exportaciones-transaccion-emision-factura-fiscal',
                        title: 'exportaciones.transacciones.page.emision_fac_fiscal',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-transaccion-emision-factura-fiscal',
                    },
                    {
                        route: 'exportaciones-transacciones-guia-remision-datos-embarque',
                        title: 'exportaciones.transacciones.page.gr_embarque',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-transacciones-guia-remision-datos-embarque',
                    },
                    {
                        route: 'exportaciones-transacciones-proceso-guia-remision',
                        title: 'exportaciones.transacciones.procesar_gr',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-transacciones-proceso-guia-remision',
                    },
                    {
                        route: 'exportaciones-transacciones-cierre-diario',
                        title: 'exportaciones.transacciones.page.cierre_diario',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-transacciones-cierre-diario',
                    },
                    {
                        route: 'exportaciones-transacciones-cierre-presidencia',
                        title: 'exportaciones.informes.page.cierre_presidencia',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-transacciones-cierre-presidencia',
                    },
                    // DOCEX
                    {
                        route: 'exportaciones-transacciones-factura-documentacion',
                        title: 'exportaciones.transacciones.page.factura_documentacion',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-transacciones-factura-documentacion',
                    },
                    // DOCEX
                    {
                        route: 'exportaciones-transacciones-ingreso-bancario',
                        title: 'exportaciones.transacciones.page.ingreso_bancario',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-transacciones-ingreso-bancario',
                    },
                    {
                        route: 'exportaciones-transacciones-emision-convalidacion-kardex',
                        title: 'exportaciones.transacciones.page.emision_convalidacion_kardex',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-transacciones-emision-convalidacion-kardex',
                    },
                    {
                        route: 'exportaciones-transacciones-ingreso-costo-proceso',
                        title: 'exportaciones.transacciones.page.ingreso_costo_proceso',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-transacciones-ingreso-costo-proceso',
                    },
                    {
                        route: 'exportaciones-transacciones-ingreso-costo-produccion',
                        title: 'exportaciones.transacciones.page.ingreso_costo_produccion',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-transacciones-ingreso-costo-produccion',
                    },
                ],
            },
            {
                title: 'Informes',
                fontIcon: 'file-prescription',
                resource: 'Exportaciones',
                action: 'ver-exportaciones-informes',
                children: [
                    {
                        route: 'exportaciones-informes-embarque-salem',
                        title: 'exportaciones.informes.page.consulta_embarque',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-informes-embarque-salem',
                    },
                    {
                        route: 'exportaciones-reportes-embarques',
                        title: 'Embarques',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-reporte-embarque',
                    },
                    {
                        route: 'exportaciones-informes-control-eta',
                        title: 'exportaciones.informes.page.control_eta',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-informes-control-eta',
                    },
                    {
                        route: 'exportaciones-informes-cobranza-mercado',
                        title: 'exportaciones.informes.page.cobranza_mercado',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-informes-cobranza-mercado',
                    },
                    {
                        route: 'exportaciones-informes-tarifa-naviera',
                        title: 'exportaciones.informes.page.consulta_tarifa',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-informes-tarifa-naviera',
                    },
                    {
                        route: 'exportaciones-informes-actualizar-booking',
                        title: 'exportaciones.informes.page.consulta_booking',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-informes-actualizar-booking',
                    },
                    {
                        route: 'exportaciones-informes-consultar-proformas',
                        title: 'exportaciones.informes.page.proforma',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-informes-consultar-proformas',
                    },
                    {
                        route: 'exportaciones-informes-consultar-cobros',
                        title: 'exportaciones.informes.page.consultar_cobros',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-informes-consultar-cobros',
                    },
                    {
                        route: 'exportaciones-informes-consultar-notas-credito',
                        title: 'exportaciones.informes.page.consultar_nota_credito',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-informes-consultar-notas-credito',
                    },
                    {
                        route: 'exportaciones-informes-consultar-notas-debito',
                        title: 'exportaciones.informes.page.consultar_nota_dedito',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-informes-consultar-notas-debito',
                    },
                    {
                        route: 'exportaciones-informes-consultar-factor-plastico',
                        title: 'exportaciones.informes.page.embarque_plastico',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-informes-consultar-factor-plastico',
                    },
                    {
                        route: 'exportaciones-informes-consultar-factura-comercial',
                        title: 'exportaciones.informes.page.consultar_fac_comercial',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-informes-consultar-factura-comercial',
                    },
                    {
                        route: 'exportaciones-informes-consultar-factura-fiscal',
                        title: 'exportaciones.informes.page.consultar_fac_fiscal',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-informes-consultar-factura-fiscal',
                    },
                    {
                        route: 'exportaciones-informes-consultar-certificados-exportacion',
                        title: 'exportaciones.transacciones.certificado_exportacion',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-informes-consultar-certificados-exportacion',
                    },
                    {
                        route: 'exportaciones-informes-consultar-factura-peso-bruto',
                        title: 'exportaciones.informes.page.consultar_peso_bruto',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-informes-consultar-factura-peso-bruto',
                    },
                    {
                        route: 'exportaciones-informes-consultar-detalles-cobros',
                        title: 'exportaciones.informes.page.detalles_cobros',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-informes-consultar-detalles-cobros',
                    },
                    {
                        route: 'exportaciones-informes-anular-detalles-booking',
                        title: 'exportaciones.informes.page.actualizar_detalle_booking',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-informes-anular-detalles-booking',
                    },
                    {
                        route: 'exportaciones-informes-saldos-clientes',
                        title: 'exportaciones.informes.page.saldo_clientes',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-informes-saldos-clientes',
                    },
                    {
                        route: 'exportaciones-informes-seguimiento-eta',
                        title: 'exportaciones.informes.page.seguimiento_eta',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-informes-seguimiento-eta',
                    },
                    {
                        route: 'exportaciones-informes-consultar-lbs-facturadas',
                        title: 'exportaciones.informes.page.lbs_facturadas',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-informes-consultar-lbs-facturadas',
                    },
                    {
                        route: 'exportaciones-informes-consultar-saldos-proformas',
                        title: 'exportaciones.informes.page.saldo_proforma',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-informes-consultar-saldos-proformas',
                    },
                    {
                        route: 'exportaciones-informes-consultar-cierre-presidencia',
                        title: 'exportaciones.informes.page.cierre_presidencia',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-informes-consultar-cierre-presidencia',
                    },
                    {
                        route: 'exportaciones-informes-consultar-lbs-detalladas',
                        title: 'exportaciones.informes.page.lbs_detalladas',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-informes-consultar-lbs-detalladas',
                    },
                    // DOCEX
                    {
                        route: 'exportaciones-informes-consultar-factura-documentacion',
                        title: 'exportaciones.informes.page.consultar_factura_documentacion',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-informes-consultar-factura-documentacion',
                    },
                    // DOCEX
                    {
                        route: 'exportaciones-informes-consultar-ingreso-bancario',
                        title: 'exportaciones.informes.page.consultar_ingreso_bancario',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-informes-consultar-ingreso-bancario',
                    },
                    {
                        route: 'exportaciones-informes-precio-retorno-finca',
                        title: 'exportaciones.informes.page.consultar_ingreso_bancario',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-informes-precio-retorno-finca',
                    },
                    {
                        route: 'exportaciones-informes-consultar-convalidacion-kardex',
                        title: 'exportaciones.informes.page.consultar_convalidacion_kardex',
                        resource: 'Exportaciones',
                        action: 'ver-exportaciones-informes-consultar-convalidacion-kardex',
                    },
                ],
            },
        ],
    },
]
